<template>
    <div type="card-full" class="card-full">
        <div class="icon-container">
            <i class="el-icon-printer icon" v-if="isPrint" v-print="printObj" @click="print"></i>
            <div v-if="$route.name === 'pjBiddingNotice'" class="download-notice" @click="downloadCollectionNotice">
                下载<span class="red-text">领取通知</span>（如有需要）
            </div>
        </div>
        <div id="printMe" class="con-box">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>

import print from 'vue-print-nb'
export default {
    name: 'printView',
    directives: {
        print   
    },
    data () {
        return {
            loading: {},
            isPrint: true,
            printObj: {
                id: "printMe",
                popTitle: '南方采购交易平台',
                beforeOpenCallback (vue) {
                    // vue.printLoading = true
                    console.log('打开之前')
                },
                openCallback (vue) {
                    // vue.printLoading = false
                    console.log('执行了打印')
                },
                closeCallback (vue) {
                    console.log('关闭了打印工具')
                }
            }
        }
    },
    methods: {
        print () {
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.isPrint = !this.isPrint
            setTimeout(() => {
                this.loading.close()
            }, 1500)
            setTimeout(() => {
                this.isPrint = !this.isPrint
            }, 500)
        },
        downloadCollectionNotice() {
            let {href} = this.$router.resolve({name: 'collectionNotice', query: {psuid: this.$route.query.psuid, projectid: this.$route.query.projectid}})
            window.open(href, '_blank')
        }
    }
}
</script>
<style lang="scss" scoped>
.card-full{
    position: relative;
    width: 100%;
    height: 100%;
}
body{
    overflow-x: hidden;
}
.con-box{
    width: 90%;
    margin: 0 auto;
}
.icon-container {
    position: fixed;
    top: 20px;
    right: 200px;
    z-index: 9999;
    text-align: center;
    width: 150px;
}

.icon {
    font-size: 46px;
    color: #fc5b2b;
    cursor: pointer;
    margin: 0 auto;
    display: block;
}

.download-notice {
    font-size: 16px;
    color: #000;
    cursor: pointer;
    text-align: center;
    line-height: 20px;
    margin-top: 10px;
}

.red-text {
    color: #FF0000;
    font-weight: bold;
}
</style>
